// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2BLEg","itemTitle":"ClientEmergencyInfo_itemTitle__2xK7r","itemText":"ClientEmergencyInfo_itemText__1YKhf"};